import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

const ModalPopup = ({
    title, 
    innerTitle, 
    textConfig, 
    textButton, 
    textButtonConfirm,
    iconSuccess = faCircleCheck,
    titleSuccess,
    textSuccess,
    errorConfig,
    loadImg,
    buttonFunction,
    sending,
    sendingTitle,
    confirmed,
    error,
    closeError,
    icon = null,
    iconButton = null,
    classNameButton,
    disableFunctionButton = false,
    addictionalComponents = null}) => {

    const [modalShow, setModalShow] = useState(false);
    
    const closingModal = (closingError) => {
      setModalShow(false);
      closingError();
    }

    function MyVerticallyCenteredModal(props) {
        
        return (
          <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
          >
            <Modal.Header closeButton={!props.sendingModal}>
              <Modal.Title id="contained-modal-title-vcenter">
                <h3 className='mb-0 text-secondary'>
                  {props.titleModal}
                </h3>
              </Modal.Title>
            </Modal.Header>
            
            { 
              props.sendingModal &&   
              <>
              <Modal.Body className='modal-popup-body'>
                <div className="text-center text-md-center mb-5 mt-6 md-0">
                  <div className="loading-logo-modal-bg">
                    <Image className="loading-logo-modal" src={props.imageLoading} />
                  </div>
                  <h3 className="mb-0 mt-6 text-primary-lc ">{props.sendingTitleModal}</h3>
                </div>
              </Modal.Body>
              <Modal.Footer className='text-center'>
              </Modal.Footer>
            </>
            }            
            { 
              props.confirmedModal &&  
              <>
                <Modal.Body className='modal-popup-body text-center'>
                  <FontAwesomeIcon icon={props.iconSuccessModal} className="mt-4 icon-success" /> 
                  <h3 className="mb-0 mt-3 text-secondary-lc">
                    {props.titleSuccessModal} 
                  </h3>
                  <h6 className="pt-3">
                    {props.textSuccessModal} 
                  </h6>  
                </Modal.Body>
                <Modal.Footer className='text-center mt-3'>
                </Modal.Footer>
              </>
            }
            { 
              props.errorModal &&  
              <>
                <Modal.Body className='modal-popup-body text-center'>
                  <FontAwesomeIcon icon={faCircleXmark} className="mt-4 icon-success" /> 
                  <h3 className="mb-0 mt-5 text-secondary-lc">
                    {props.errorModalConfig.title}
                  </h3>
                  <h6 className="pt-3">
                    {props.errorModalConfig.text}
                    {props.errorModalConfig.link}
                  </h6>  
                </Modal.Body>
                <Modal.Footer className='text-center'>
                </Modal.Footer>
              </>
            }
            {
              (!props.confirmedModal && !props.sendingModal && !props.errorModal) && 
              <>
                <Modal.Body className='modal-popup-body'>
                  <div className='w-100 text-center'>
                    {props.iconModal}
                  </div>
                  <h5><b>{props.innerTitleModal}</b></h5>
                  <p className='pt-0'>
                    {props.textModal.top}<br/>
                    {props.textModal.bottom}
                  </p>
                </Modal.Body>

                {props.addictionalComponentsModal}

                {props.buttonFunctionModal &&
                  <Modal.Footer className='text-center'>
                    <Button disabled={disableFunctionButton} className="m-auto w-50" onClick={props.buttonFunctionModal}>{props.textButtonConfirmModal}</Button>
                  </Modal.Footer>
                }
              </>
            }
          </Modal>
        );
    }

    return(
      <>
        <Button variant="primary" className={classNameButton} onClick={() => setModalShow(true)}>
          {textButton} {iconButton}
        </Button>
        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => closingModal(closeError)}
          titleModal={title}
          innerTitleModal = {innerTitle}
          textModal = {textConfig} 
          textButtonConfirmModal = {textButtonConfirm}
          titleSuccessModal = {titleSuccess}
          textSuccessModal = {textSuccess}
          errorModalConfig = {errorConfig}
          imageLoading = {loadImg}
          buttonFunctionModal = {buttonFunction}
          sendingModal = {sending}
          sendingTitleModal = {sendingTitle}
          confirmedModal = {confirmed}
          errorModal = {error}
          iconModal = {icon}
          addictionalComponentsModal = {addictionalComponents}
          iconSuccessModal = {iconSuccess}
        />
      </>
    )
}

export default ModalPopup;